exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-change {\n  position: relative;\n}\n.icon-change i {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translate(-50%, -50%);\n}", ""]);

// exports
